import { useState } from "react";
import { QRCode } from "react-qr-code";
import { QR_TEXT } from "../../system/constants";

const QrCodeInput = () => {
  const [qrText, setQRText] = useState("");
  const handleInputChange = e => setQRText(e.target.value);

  return (
    <div style={{ display: "block", marginTop: "15px" }}>
      <div style={{ display: "inline-block", padding: "16px" }}>
        <QRCode value={qrText} size={200} />
        <input
          type="text"
          value={qrText}
          onChange={handleInputChange}
          placeholder={QR_TEXT.PLACEHOLDER}
          style={{ fontSize: "16px", width: "200px", border: 0, outline: 0, padding: "5px", marginTop: "10px" }}
        />
      </div>
    </div>
  );
};

export default QrCodeInput;
